import store from '../store';

/**
 * 视觉大模型接口API
 */
export default {
    /**
     * 查询识别类型列表
     */
    async getList () {
        let token = store.state.account.token;
        const API = '/call-platform/visualModelObjectType/list';
        let headers = { 'Content-Type': 'application/x-www-form-urlencoded', 'Authorization': token };
        let resp = await fetch(API, { method: 'GET', headers });
        if (resp.status !== 200) {
            throw new Error(`接口【${API}】请求失败`);
        }
        let ret = await resp.json();

        // 401表示token过期，需要重新登录
        if (ret.statusCode === 401) {
            store.commit('account/logout');
            return;
        }
        // 其他错误
        if (ret.statusCode !== 200) {
            throw new Error(ret.opDesc);
        }
        return ret;
    },
    /**
     * 删除类别
     */
    async deleteThing (typeIds) {
        let token = store.state.account.token;
        const API = '/call-platform/visualModelObjectType/delete?typeIds=' + typeIds;
        let headers = { 'Content-Type': 'application/x-www-form-urlencoded', 'Authorization': token };
        let resp = await fetch(API, { method: 'GET', headers });
        if (resp.status !== 200) {
            throw new Error(`接口【${API}】请求失败`);
        }
        let ret = await resp.json();

        // 401表示token过期，需要重新登录
        if (ret.statusCode === 401) {
            store.commit('account/logout');
            return;
        }
        // 其他错误
        if (ret.statusCode !== 200) {
            return {
                fail: true,
                msg: ret.opDesc
            };
        }
        return ret;
    },
    /**
     * 新增识别类型
     */
    async addThing (payload) {
        let token = store.state.account.token;
        const API = '/call-platform/visualModelObjectType/add';
        let body = JSON.stringify(payload);
        let headers = { 'Content-Type': 'application/json', 'Authorization': token };
        let resp = await fetch(API, { method: 'POST', body, headers });
        if (resp.status !== 200) {
            throw new Error(`接口【${API}】请求失败`);
        }
        let ret = await resp.json();

        // 401表示token过期，需要重新登录
        if (ret.statusCode === 401) {
            store.commit('account/logout');
            return;
        }
        // 其他错误
        if (ret.statusCode !== 200) {
            return {
                fail: true,
                msg: ret.opDesc
            };
        }
        return ret;
    },
    // 大模型推理服务接口
    async handleImg (payload) {
        const API = '/picture-demo/handle';
        let body = JSON.stringify(payload);
        let headers = { 'Content-Type': 'application/json' };
        let resp = await fetch(API, { method: 'POST', body, headers });
        let ret = await resp.json();
        return ret;
    },
    /**
     * 分页查询图片列表
     */
    async getImgList (pageNo, pageSize) {
        let token = store.state.account.token;
        const API = '/call-platform/visualModelPic/page?pageNo=' + pageNo + '&pageSize=' + pageSize;
        let headers = { 'Content-Type': 'application/x-www-form-urlencoded', 'Authorization': token };
        let resp = await fetch(API, { method: 'GET', headers });
        if (resp.status !== 200) {
            throw new Error(`接口【${API}】请求失败`);
        }
        let ret = await resp.json();
        // 401表示token过期，需要重新登录
        if (ret.statusCode === 401) {
            store.commit('account/logout');
            return;
        }
        // 其他错误
        if (ret.statusCode !== 200) {
            return {
                fail: true,
                msg: ret.opDesc
            };
        }
        return ret;
    },
    // 上传图片
    async uploadImg (file) {
        let token = store.state.account.token;
        const API = '/call-platform/visualModelPic/uploadPic';
        let body = new FormData();
        body.append('file', file);
        let headers = { 'Authorization': token };
        let resp = await fetch(API, { method: 'POST', body, headers });
        let ret = await resp.json();
        // 401表示token过期，需要重新登录
        if (ret.statusCode === 401) {
            store.commit('account/logout');
            return;
        }
        // 其他错误
        if (ret.statusCode !== 200) {
            return {
                fail: true,
                msg: ret.opDesc
            };
        }
        return ret;
    }
};
